import { closePeriodServices } from '../../helpers/services/closePeriod.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const PERIOD_MODULE = 'closePeriod'; 

// define action 
export const GET_ALL_CLOSE_PERIODS = 'getAllClosePeriods';
export const GET_CLOSE_PERIOD = 'getClosePeriod';
export const UPDATE_CLOSE_PERIOD = 'updateClosePeriod';
export const CREATE_CLOSE_PERIOD = 'createClosePeriod';
export const UPDATE_CLOSE_PERIOD_STATUS = 'updateClosePeriodStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_CLOSE_PERIOD_REQUEST = "getAllClosePeriods";
const GET_CLOSE_PERIOD_REQUEST = "getClosePeriod";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_CLOSE_PERIODS]({ commit }, { filter }) {
        closePeriodServices
            .getAllClosePeriods(filter)
            .then(
                (result) => {
                    commit(GET_ALL_CLOSE_PERIOD_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_CLOSE_PERIOD]({ commit }, { id }) {
       await closePeriodServices
            .getClosePeriod(id)
            .then(
                (result) => {
                    commit(GET_CLOSE_PERIOD_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_CLOSE_PERIOD]({ commit }, { data }) {
        commit(REQUEST)
        closePeriodServices
            .updateClosePeriod(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.closePeriod')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_CLOSE_PERIOD]({ commit }, { data }) {
        commit(REQUEST)
        closePeriodServices
            .createClosePeriod(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess",[i18n.t('module.closePeriod')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_CLOSE_PERIOD_STATUS]({ dispatch }, { filter, data }) {
        closePeriodServices
            .updateClosePeriodStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_CLOSE_PERIODS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Close-period-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true, processing: true };
    },
    [GET_ALL_CLOSE_PERIOD_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                startTime: o.start_operate_time,
                closeTime: o.close_operate_time,
                isWholeDay: o.is_whole_day,
                location: o.location,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
            }
        })
    },
    [GET_CLOSE_PERIOD_REQUEST](state, data) {
        let o = data.data

        state.details = {
            companyLocationID: o.location != null ? {
                value: o.location.uuid,
                text: o.location.name
            } : '',
            uuid: o.uuid,
            name: o.name,
            startTime: o.start_operate_time,
            closeTime: o.close_operate_time,
            isWholeDay: o.is_whole_day,
            location: o.location,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
            updatedBy: o.updated_by,
            updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
        }

    }
}


